import { AppRouteProps } from "@harea/component";
import React from "react";

const OvertimeContainer = React.lazy(
  () => import("./container/OvertimeContainer"),
);

export const OvertimeRoutes: Array<AppRouteProps> = [
  {
    path: "overtimes",
    element: <OvertimeContainer />,
  },
];
